import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateLoader } from "@ngx-translate/core";
import { Observable, catchError, of, forkJoin, map } from "rxjs";
import * as modules from "../../../i18n/module-names.json";
import * as coreModules from "../../../i18n/module-shared.json";
import * as layoutsModules from "../../../i18n/module-layouts.json";

@Injectable({
  providedIn: "root",
})
export class CustomTranslateHttpLoader implements TranslateLoader {
  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    const basePaths = [
      "./i18n/components-translation/",
      "./i18n/shared/",
      "./i18n/layouts/",
    ];

    let dataArr = [
      ...Object.values(JSON.parse(JSON.stringify(modules)).default),
    ];
    let dataArr2 = [
      ...Object.values(JSON.parse(JSON.stringify(coreModules)).default),
    ];
    let dataArr3 = [
      ...Object.values(JSON.parse(JSON.stringify(layoutsModules)).default),
    ];

    const requests = [
      dataArr.map((folder) =>
        this.http.get(`${basePaths[0]}${folder}/${lang}.json`).pipe(
          map((response: any) => {
            return response || {};
          }),
          catchError((error) => {
            return of({}); // Return empty object instead of failing
          })
        )
      ),
      dataArr2.map((folder) =>
        this.http.get(`${basePaths[1]}${folder}/${lang}.json`).pipe(
          map((response: any) => {
            return response || {};
          }),
          catchError((error) => {
            return of({}); // Return empty object instead of failing
          })
        )
      ),
      dataArr3.map((folder) =>
        this.http.get(`${basePaths[2]}${folder}/${lang}.json`).pipe(
          map((response: any) => {
            return response || {};
          }),
          catchError((error) => {
            return of({}); // Return empty object instead of failing
          })
        )
      ),
    ].flat();

    return forkJoin(requests.length > 0 ? requests : [of({})]).pipe(
      map((responses) => {
        // Filter out empty responses and deep merge all translation objects
        const validResponses = responses.filter(
          (response) =>
            response &&
            typeof response === "object" &&
            Object.keys(response).length > 0
        );

        if (validResponses.length === 0) {
          return {};
        }

        const mergedTranslations = this.deepMerge({}, ...validResponses);

        return mergedTranslations;
      }),
      catchError((error) => {
        return of({}); // Return empty object as fallback
      })
    );
  }

  private deepMerge(target: any, ...sources: any[]): any {
    if (!sources.length) return target;
    const source = sources.shift();

    if (this.isObject(target) && this.isObject(source)) {
      for (const key in source) {
        if (this.isObject(source[key])) {
          if (!target[key]) Object.assign(target, { [key]: {} });
          this.deepMerge(target[key], source[key]);
        } else {
          Object.assign(target, { [key]: source[key] });
        }
      }
    }

    return this.deepMerge(target, ...sources);
  }

  private isObject(item: any): boolean {
    return item && typeof item === "object" && !Array.isArray(item);
  }
}
